/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetAllCountriesQuery as AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesQuery } from '../models/ace/xFound/Portal/Core/CAQ/Country/Queries/get-all-countries-query';
import { GetAllCountriesResponse as AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse } from '../models/ace/xFound/Portal/Core/CAQ/Country/Queries/get-all-countries-response';

@Injectable({
providedIn: 'root',
})

export class CountryService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiCountryGet
   */
  static readonly ApiCountryGetPath = '/api/Country';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCountryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryGet$Plain$Response(params?: {
    query?: AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CountryService.ApiCountryGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCountryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryGet$Plain(params?: {
    query?: AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesQuery;
  }): Observable<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse> {

    return this.apiCountryGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>) => r.body as AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCountryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryGet$Response(params?: {
    query?: AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CountryService.ApiCountryGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCountryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryGet(params?: {
    query?: AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesQuery;
  }): Observable<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse> {

    return this.apiCountryGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse>) => r.body as AceXFoundPortalCoreCaqCountryQueriesGetAllCountriesResponse)
    );
  }

}